import type { ConnectorDefinition } from "../types";

export const slackConnector: ConnectorDefinition = {
  id: "slack",
  name: "Slack",
  description: "Connect to Slack for team communication",
  icon: "slack",
  authType: "oauth",
  oauth: {
    authorizationUrl: "https://slack.com/oauth/v2/authorize",
    tokenUrl: "https://slack.com/api/oauth.v2.access",
    // No BOT token scopes. Magnus's Slack connector acts exclusively as the
    // connected user (see getUserSlackClient), so it requests no bot scopes
    // and never receives — let alone uses — a bot token. An empty `scopes`
    // array makes getAuthorizationUrl omit the `scope` param entirely, which
    // Slack treats as a user-token-only install (only `user_scope` is sent).
    // The connector layer recognizes "no bot scopes" as user-token-only and
    // skips all bot-token fetch/validation for it.
    scopes: [],
    // Magnus's Slack connector acts exclusively as the connected user (the
    // bot token is never used at call time — see getUserSlackClient), so the
    // USER token must carry every scope the tools need: reads, search, and
    // writes. Keep this in sync with the Slack API calls in
    // `packages/features/ai/src/capabilities/slack/tools/*`.
    userScopes: [
      // Conversation metadata (list/info via users.conversations)
      "channels:read",
      "groups:read",
      "im:read",
      "mpim:read",
      // Message history (conversations.history / conversations.replies)
      "channels:history",
      "groups:history",
      "im:history",
      "mpim:history",
      // Content reads — all scoped to what the user can see
      "files:read",
      "pins:read",
      "reactions:read",
      "canvases:read",
      "users:read",
      "users.profile:read",
      "users:read.email",
      "search:read",
      // Writes — performed as the user
      "chat:write",
      "channels:write",
      "groups:write",
      "im:write",
      "mpim:write",
      "files:write",
      "reactions:write",
      "canvases:write",
    ],
    clientIdEnvVar: "SLACK_CLIENT_ID",
    clientSecretEnvVar: "SLACK_CLIENT_SECRET",
  },
  isEnabled: () =>
    Boolean(process.env.SLACK_CLIENT_ID && process.env.SLACK_CLIENT_SECRET),
};
